import { Component, EventEmitter, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { showErrorSwal } from '@asamco/utils';
import Swal from 'sweetalert2';
import { ApplicationLoginService } from '../../services/application-login.service';

@Component({
	selector: 'al-link-edit-application-login-article-admin',
	standalone: true,
	imports: [NgIf, FormsModule],
	templateUrl: './link-edit-application-login-article-admin.component.html',
	styleUrls: ['./link-edit-application-login-article-admin.component.scss'],
})
export class LinkEditApplicationLoginArticleAdminComponent {
	@Output() articlesSaved = new EventEmitter<{applicationId: number, freshdeskArticleIds: number[], appSide: string}>();

	public visible = false;
	public saving = false;
	public appSide: string;
	public articleIdsText = '';
	public applicationName = '';

	private applicationId: number | null = null;

	constructor(private appLoginService: ApplicationLoginService) {}

	public open(applicationId: number, appSide: string, applicationName?: string): void {
		if (!applicationId) return;

		this.applicationId = applicationId;
		this.appSide = appSide;
		this.applicationName = applicationName ?? '';
		this.articleIdsText = '';
		this.visible = true;

		this.appLoginService.getApplicationArticles(applicationId).subscribe({
			next: ids => this.articleIdsText = (ids ?? []).join(', '),
			error: showErrorSwal,
		});
	}

	public close(): void {
		this.visible = false;
		this.saving = false;
	}

	public save(): void {
		if (!this.applicationId) return;

		this.saving = true;

		const freshdeskArticleIds = this.parseArticleIds(this.articleIdsText);

		this.appLoginService.updateLoginArticles(this.applicationId, freshdeskArticleIds).subscribe({
			next: result => {
				this.saving = false;

				if (!result?.success) return;

				this.articlesSaved.emit({ applicationId: this.applicationId!, freshdeskArticleIds, appSide: this.appSide });
				this.close();
				Swal.fire({ icon: 'success', text: 'Linked articles updated.' });
			},
			error: error => {
				this.saving = false;
				showErrorSwal(error);
			},
		});
	}

	private parseArticleIds(input: string | null | undefined): number[] {
		return Array.from(
			new Set(
				(input ?? '')
					.split(/[\s,;]+/g)
					.map(value => value.trim())
					.filter(Boolean)
					.map(value => Number(value))
					.filter(value => Number.isFinite(value) && value > 0)
			)
		);
	}
}

